import { Matchup } from '../types';

export interface WeekRange {
  minWeek: number | null;
  maxWeek: number | null;
  weeks: number[];
}

/** Sorted unique weeks present in the matchups, with min/max. */
export const getWeekRange = (matchups: Matchup[]): WeekRange => {
  if (matchups.length === 0) return { minWeek: null, maxWeek: null, weeks: [] };
  const weeks = Array.from(new Set(matchups.map(m => m.week))).sort((a, b) => a - b);
  return { minWeek: weeks[0], maxWeek: weeks[weeks.length - 1], weeks };
};

/** Clamp a week into [min, max]. */
export const clampWeek = (week: number, min: number, max: number): number =>
  Math.min(Math.max(week, min), max);
